import React from 'react';
import Header from './Header';
import Footer from './Footer';

const OtherNutraceuticalProducts = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
            .table td, .table th {
                word-break: break-word;
                white-space: normal;
                vertical-align: top;
            }
            .table ul {
                padding-left: 1.2em;
                margin-bottom: 0;
            }
            .table li {
                word-break: break-word;
                white-space: normal;
            }
        </style>

        <div id="wrapper">
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Other Nutraceutical Products</h2>
                            <p>Discover our comprehensive range of specialized nutraceutical formulations</p>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="content">
                <div class="content-wrap py-0">
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Specialized Formulations</h2>
                                    <p>Innovative nutraceutical solutions for specific health needs</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- SUBLINGUAL TABLETS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#sublingual">
                                                    <i class="bi bi-capsule me-2"></i>SUBLINGUAL TABLETS
                                                </button>
                                            </h2>
                                            <div id="sublingual" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>B12 500 mcg Sublingual Tablets</td>
                                                                    <td>Fast-absorbing vitamin B12 with pleasant flavor</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vitamin D3 60000 IU Sublingual Tablets</td>
                                                                    <td>High-potency vitamin D3 with flavor for easy administration</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SUSTAINED RELEASE SUPPLEMENTS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sustainedRelease">
                                                    <i class="bi bi-capsule me-2"></i>SUSTAINED RELEASE SUPPLEMENTS
                                                </button>
                                            </h2>
                                            <div id="sustainedRelease" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Melatonin 3 mg Sustained Release Tablets</td>
                                                                    <td>Extended-release melatonin for better sleep quality</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vitamin C 1000 mg Sustained Release Tablets</td>
                                                                    <td>Long-lasting vitamin C for continuous antioxidant support</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Caffeine 200 mg Sustained Release Tablets</td>
                                                                    <td>Extended-release caffeine for sustained energy</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- HANGOVER RELIEF -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#hangoverRelief">
                                                    <i class="bi bi-capsule me-2"></i>HANGOVER RELIEF
                                                </button>
                                            </h2>
                                            <div id="hangoverRelief" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Taurine, Creatine, BCAA, Glutamine with Vitamin B Complex, C and Minerals Effervescent Tablets</td>
                                                                    <td>Comprehensive formula for hangover relief and recovery</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- CAPSULES FILLED WITH PELLETS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pelletCapsules">
                                                    <i class="bi bi-capsule me-2"></i>CAPSULES FILLED WITH PELLETS
                                                </button>
                                            </h2>
                                            <div id="pelletCapsules" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Amino Acid Pellets in Capsules</td>
                                                                    <td>Essential amino acids in controlled-release pellets</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Multivitamins Pellets in Capsules</td>
                                                                    <td>Complete multivitamin formula in pellet form</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Ferrous Sulphate, Folic Acid Pellets in Capsules</td>
                                                                    <td>Iron and folic acid combination in pellet form</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- FERTILITY SUPPORT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fertilitySupport">
                                                    <i class="bi bi-capsule me-2"></i>FERTILITY SUPPORT
                                                </button>
                                            </h2>
                                            <div id="fertilitySupport" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>CATEGORY</th>
                                                                    <th>PRODUCTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Fertility Support for Her</td>
                                                                    <td>Myo-Inositol, D-Chiro Inositol, L-Methyl Folate, Vitamin D3, Chromium Picolinate Tablets</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Fertility Support for Him</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Maca Extract, Green Tea Extract, Arginine and Carnitine with Vitamins and Minerals Tablets</li>
                                                                            <li>CoQ10, Ginseng Extract, Ashwagandha, L-Carnitine with Zinc Tablets</li>
                                                                            <li>Saw Palmetto Extract Capsules</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- LIVER SUPPORT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#liverSupport">
                                                    <i class="bi bi-capsule me-2"></i>LIVER SUPPORT
                                                </button>
                                            </h2>
                                            <div id="liverSupport" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Milk Thistle (Silymarin) Extract with Curcumin, Choline, Ginger, Licorice, Beet Root Extract, Inositol Tablets</td>
                                                                    <td>Comprehensive liver support formula</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Milk Thistle (Silymarin) Extract with N Acetyl Cysteine, Ornithine, CoQ10, Artichoke Extract and Glutathione Capsules</td>
                                                                    <td>Advanced liver health formula with antioxidants</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- TESTO BOOSTER -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#testoBooster">
                                                    <i class="bi bi-capsule me-2"></i>TESTO BOOSTER
                                                </button>
                                            </h2>
                                            <div id="testoBooster" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Fulvic Acid, D-Aspartic Acid, Tribulus Terrestris, Ashwagandha Extract, Fenugreek Extract 400mg, Safed Muesli Extract 300mg + Zinc Citrate 57mg + Vit D3 600IU Capsules</td>
                                                                    <td>Comprehensive testosterone support formula</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Cordyceps Militaris Extract (>20% Beta Glucans) Capsules</td>
                                                                    <td>High-potency cordyceps extract</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Mushroom Complex (Chaga, Lions Mane, Reishi, Cordyceps, Maitake, Shitake) Capsules</td>
                                                                    <td>Complete mushroom blend for vitality</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- PROSTATE HEALTH -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#prostateHealth">
                                                    <i class="bi bi-capsule me-2"></i>PROSTATE HEALTH
                                                </button>
                                            </h2>
                                            <div id="prostateHealth" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Beta-Sitosterol (From Plant Sterol Complex) Capsules</td>
                                                                    <td>Natural plant sterol for prostate health</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Saw Palmetto Extract with Beta Sitosterol, Nettle Extract and Boron Capsules</td>
                                                                    <td>Comprehensive prostate support formula</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- PLANT / VEGAN SUPPLEMENTS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#plantVegan">
                                                    <i class="bi bi-capsule me-2"></i>PLANT / VEGAN SUPPLEMENTS
                                                </button>
                                            </h2>
                                            <div id="plantVegan" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Plant Based Protein Powder</td>
                                                                    <td>Complete plant protein source</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Super Green Powder (Chlorella, Barley Grass, Kale, Moringa, Broccoli)</td>
                                                                    <td>Nutrient-rich green superfood blend</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Plant Based Biotin Powder</td>
                                                                    <td>Vegan biotin supplement</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Plant Based Collagen Powder</td>
                                                                    <td>Vegan collagen alternative</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Plant Based Gainers</td>
                                                                    <td>Vegan mass gainer formula</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- NUTRACEUTICAL CHEWABLE TABLETS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#chewableTablets">
                                                    <i class="bi bi-capsule me-2"></i>NUTRACEUTICAL CHEWABLE TABLETS
                                                </button>
                                            </h2>
                                            <div id="chewableTablets" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Vitamin C + Zinc + Vitamin D3 Chewable Tablets</td>
                                                                    <td>Available in various flavors</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Calcium + Vitamin D3 Chewable Tablets</td>
                                                                    <td>Available in various flavors</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Pre Biotics & Pro Biotics Chewable Tablets</td>
                                                                    <td>Available in various flavors</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vitamin B Complex Chewable Tablets</td>
                                                                    <td>Available in various flavors</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Multivitamins + Multimineral with DHA Chewable Tablets (Kids)</td>
                                                                    <td>Available in various flavors</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Glucose with Minerals and Vitamins Chewable Tablets</td>
                                                                    <td>Available in various flavors</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Digestive Enzymes Chewable Tablets</td>
                                                                    <td>Easy-to-take digestive support</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Iron Chewable Tablets for Kids</td>
                                                                    <td>Child-friendly iron supplement</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- MOUTH DISSOLVING TABLETS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#mouthDissolving">
                                                    <i class="bi bi-capsule me-2"></i>MOUTH DISSOLVING TABLETS
                                                </button>
                                            </h2>
                                            <div id="mouthDissolving" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>DESCRIPTION</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Methylcobalamine Mouth Dissolving Tablets</td>
                                                                    <td>Available with flavor</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Melatonin Mouth Dissolving Tablets</td>
                                                                    <td>Available with flavor</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Biotin Mouth Dissolving Tablets</td>
                                                                    <td>Available with flavor</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Zinc Mouth Dissolving Tablets</td>
                                                                    <td>Available with flavor</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Vitamin D3 Mouth Dissolving Tablets</td>
                                                                    <td>Available with flavor</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default OtherNutraceuticalProducts; 